import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import messageActions from "../actions/messageActions";
import {
  InputText,
  Dropdown,
  Loading,
  Valert,
  Vmodal,
  Highlighted,
  UpdatedHighlighted,
  SearchIcon,
} from "../components";
import { Row, Col, Button, Form, FormGroup, Alert, Input } from "reactstrap";
import { Field, reduxForm, change, isDirty } from "redux-form";
import { getLoggedInUser, isLoggedIn } from "../services/AuthenticationService";
import moment from "moment";
import classNames from "classnames";
import { handleUnitDropdown, checkInput, isZeroEquivalent, AmountHandlers } from "../lib/helper";
import {
  IS_UNSAVED,
  DRUG_UNITS,
  FOOD_UNITS,
  PCP_UNITS,
  SUP_UNITS,
} from "../actions/constant";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome/index.es.js";  // This import only works for FA v6.7.2 + react-fontawesome@0.1.18. 
import { faMagnifyingGlass } from "@fortawesome/pro-regular-svg-icons";

const UnitDropdown = ({
  name,
  value,
  options = [],
  placeholder = "",
  disabled = false,
  onChange,
  style = {},
}) => {
  const finalValue = value || "";
  return (
    <div className="select_box">
      <select
        name={name}
        className={"form-control"}
        value={finalValue}
        disabled={disabled}
        onChange={(e) => onChange && onChange(e.target.value)}
        style={{
          height: "33.59px",
          border: 0,
          color: disabled ? "#A9A9A9" : "#000",
          backgroundColor: disabled ? "#f5f5f5" : "#fff",
          ...style,
        }}
      >
        {(!disabled && placeholder) ? <option value="">{placeholder}</option> : null}
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label} {/* no t() here: unit labels often contain ":" */}
          </option>
        ))}
      </select>
    </div>
  );
};

// Map backend category strings to your helper’s category codes
const mapCategoryKeyToCode = (key) => {
  if (!key) return "";
  const k = String(key).toLowerCase();
  const map = {
    symptom: "01",
    food: "02",
    activity: "03",
    pcp: "04",
    drug: "05",
    supplement: "06",
    location: "07",
  };
  return map[k] || key;
};

// Accepts string | array | {$numberLong} -> returns array<string>
const normalizeIdList = (x) => {
  if (Array.isArray(x)) return x;
  if (!x) return [];
  if (typeof x === "string") return x ? [x] : [];
  if (typeof x === "object" && x.$numberLong) return [String(x.$numberLong)];
  return [];
};

// Build options via your handleUnitDropdown helper
const buildUnitOptions = (categoryKey, idList) => {
  // for Food your helper recognizes "02" OR "999"; prefer "02"
  const catCode = mapCategoryKeyToCode(categoryKey);

  // Use your shared helper to get the option list
  const opts = handleUnitDropdown(catCode, { unitList: idList });

  return opts;
};

// Decide if dropdown must be disabled by the “single non-910” rule
const mustDisableByRule = (idList) =>
  Array.isArray(idList) && idList.length === 1 && idList[0] !== "910";

class MessageForm extends Component {
  render() {
    const { messageForm, messageFilter, onChangeForm, myId } = this.props;
    return (
      <div>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
          }}
        >
          <FormGroup row>
            <Col>
              <Field
                name="sortBy"
                component={Dropdown}
                options={[
                  {
                    label: this.props.t("inbox.NEW_DROPDOWN_OPTION"),
                    value: "new",
                  },
                  {
                    label: this.props.t("inbox.OLD_DROPDOWN_OPTION"),
                    value: "old",
                  },
                  {
                    label: this.props.t("inbox.SENDER_ID_ASCENDING"),
                    value: "ascending",
                  },
                  {
                    label: this.props.t("inbox.SENDER_ID_DESCENDING"),
                    value: "descending",
                  },
                ]}
                className="sortBy"
                val={messageForm.sortBy}
                placeholder={this.props.t(
                  "recipe_management.SORT_DROPDOWN_PLACEHOLDER"
                )}
                disabled={!!this.props.selectedConversation}
              />
            </Col>
            <Col>
              <div
                className="inputWithIcon"
                style={{
                  width: "100%",
                  position: "relative",
                }}
              >
                <Input
                  type="search"
                  placeholder={this.props.t("forum.SEARCH_KEYWORD_LABEL")}
                  onChange={(e) => {
                    onChangeForm(e.target.value, "search", myId);
                  }}
                  name="search"
                  autoComplete="off"
                  value={this.props.messageForm.search || ""}
                  disabled={this.props.selectedConversation ? true : false}
                />
                {/* <i
                  className="fa fa-search"
                  style={{
                    color: this.props.selectedConversation && "#bbb",
                    cursor: "default",
                    fontSize: "1rem",
                    marginRight: 9,
                    marginTop: 3,
                  }}
                /> */}

                <FontAwesomeIcon
                  className="fa fa-search"
                  icon={faMagnifyingGlass}
                  style={{
                    color: this.props.selectedConversation && "#bbb",
                    cursor: "default",
                    fontSize: "1rem",
                    marginRight: 9,
                    marginTop: 3,
                  }}
                />

              </div>
            </Col>
          </FormGroup>
        </Form>
      </div>
    );
  }
}

MessageForm = reduxForm({
  form: "messageForm",
  // onChange: (values, dispatch, props, prev) => { props.submit(); },

  onChange: (values, dispatch, props, prev) => {
    const sortChanged   = prev && prev.sortBy !== values && values.sortBy;
    const searchChanged = prev && prev.search !== values && values.search;
    const composing     = !!props.selectedConversation; // Text Area enabled?
    if ((sortChanged || searchChanged) && !composing) {
      props.submit();
    }
  },

  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
})(MessageForm);

MessageForm = connect((state) => ({
  initialValues: state.message.messageForm,
}))(MessageForm);

class MessagingInbox extends Component {
  constructor(props) {
    super(props);
    this.TwelveU12Amt = AmountHandlers("fraction");
    this.userAmt = AmountHandlers("fraction");
    this.state = {
      arrowUp: false,
      flow: false,
      allMessages: [],
      showDirtyPrompt: false,
      promptObj: {},
      myId: null,
      showClearPrompt: false,
      showRedirectPrompt: false,
      isLinkPrompt: null,
      showUnitModal: false,
      convertForm: {
        TwelveU12Unit: "",
        userUnit: "",
        TwelveU12Amount: "",
        userAmount: "",
      },
      unitDD: {
        TwelveU12Options: [],
        userOptions: [],
        TwelveU12Disabled: false,
        userDisabled: false,
      },
      unitMeta: {
        current_unit_list: [],
        final_unit_list: [],
        current_category: null,
        final_category: null,
        final_id: null,
        current_id: null,
        message_id: null,
        upc: null,
      },
    };
  }
  async componentDidMount() {
    this.loggedInUser = await getLoggedInUser();
    this.setState({ myId: this.loggedInUser._id });
    await this.props.initialize(this.loggedInUser._id);
    if (this.props.forumPost && this.props.forumPost != "null") {
      this.props.selectForEdit();
    }
  }
  componentDidUpdate(prevProps) {
    const { messages = [] } = this.props;
    if (
      messages.length > 0 &&
      (prevProps.messages === undefined || prevProps.messages.length === 0)
    ) {
      this.updateAllMessages();
    }
  }

  componentWillUnmount() {
    this.props.onChangeForm("", "search", this.loggedInUser._id); // Call onChangeForm with appropriate parameters
    // For example, remove any event listeners, cancel API requests, etc.
  }

  updateAllMessages = () => {
    let messagesList = this.props.messages[0];
    const allMessages = messagesList.messages.map((m) => ({
      ...m,
      isTruncated: false,
    }));
    this.setState({ allMessages });
  };

  handleSubmit(draft = false) {
    let message;
    if (
      this.props.selectedConversation &&
      this.props.selectedConversation === "new"
    ) {
      message = {
        post_id: this.props.selectedPost,
        message: this.props.messageForm.message,
        is_draft: draft,
      };
    } else {
      if (this.props.selectedPost && this.props.selectedPost.length > 0) {
        message = {
          post_id: this.props.selectedPost,
          conversation_id: this.props.selectedConversation,
          message: this.props.messageForm.message,
          is_draft: draft,
        };
      } else {
        message = {
          // post_id: this.props.selectedPost,
          conversation_id: this.props.selectedConversation,
          message: this.props.messageForm.message,
          is_draft: draft,
        };
      }
    }
    this.props.messageSubmit(message);
  }
  handlePublish(is_draft = false) {
    let message = {
      post_id: this.props.selectedPost,
      conversation_id: this.props.selectedConversation,
      _id: this.props.draftId,
      message: this.props.messageForm.message,
      is_draft: is_draft,
    };

    // this.props.onPublishDraft(this.props.draftId);
    this.props.messageUpdate(message);
  }
  handleDelete = (id, i) => {
    this.deleteAlert.changeStatus();
    this.deleteId = id;
    this.deleteIndex = i;
    this.setState({ deleteIndex: i });
    setTimeout(() => {
      this.setState({ showDirtyPrompt: false });
    }, 500);
  };

  handleFilter(values) {
    if (this.props.selectedConversation) return; // ignore while writing a message

    if (values && values.sortBy) {
      this.props.messageFilter(values.sortBy);
    }
  }

  handleReply(con, post, i) {
    if (this.props.messageForm.message && this.props.newDraft) {
      this.unfinishedReply.changeStatus();
      this.setState({ showDirtyPrompt: false, promptObj: {} });
    } else if (
      this.props.isDirty &&
      this.props.messageForm.message != this.props.selectedDraft
    ) {
      this.setState({ showDirtyPrompt: true, promptObj: { con, post, i } });
    } else {
      this.props.clearDirtyDraft();
      this.setState({ showDirtyPrompt: false, promptObj: {} });
      this.props.selectForEdit(con, post, i);
    }
    this.conId = con;
    this.postId = post;
    this.selectedIndex = i;
  }
  posClicked() {
    this.props.selectForEdit(this.conId, this.postId, this.selectedIndex);
  }

  handlePostLinkClick() {
    this.setState({ isDraftDirty: !this.state.isDraftDirty });
  }

  // Opening Contributed Item Unit Conversion modal
  openUnitModal = (companyItem) => {
    if (companyItem && typeof companyItem.preventDefault === "function") {
      companyItem.preventDefault();
      return;
    }

    // companyItem is the "Incompatible Measurement Unit" payload object
    const currentList = normalizeIdList(companyItem.current_unit);
    const finalList = normalizeIdList(companyItem.final_unit);

    // Build options using your helper
    // For Food: your helper also honors special "910" handling internally
    const userOptions = buildUnitOptions(companyItem.current_category, currentList);
    const TwelveU12Options = buildUnitOptions(companyItem.final_category, finalList);

    // Disable if a single, non-910 ID is forced by backend
    const userDisabled = mustDisableByRule(currentList);
    const TwelveU12Disabled = mustDisableByRule(finalList);

    // Preselect values in the "forced single" case
    const nextConvertForm = { ...this.state.convertForm };
    if (userDisabled && currentList.length === 1) {
      nextConvertForm.userUnit = currentList[0];
    } else if (!userDisabled && !userOptions.find(o => o.value === nextConvertForm.userUnit)) {
      // reset if previous selection not in options
      nextConvertForm.userUnit = "";
    }

    if (TwelveU12Disabled && finalList.length === 1) {
      nextConvertForm.TwelveU12Unit = finalList[0];
    } else if (!TwelveU12Disabled && !TwelveU12Options.find(o => o.value === nextConvertForm.TwelveU12Unit)) {
      nextConvertForm.TwelveU12Unit = "";
    }

    this.setState({
      showUnitModal: true,
      unitDD: {
        userOptions,
        TwelveU12Options,
        userDisabled,
        TwelveU12Disabled,
      },
      convertForm: nextConvertForm,
      // keep the selected item in state if you need it when submitting
      activeUnitItem: companyItem,
    });
  };

  closeUnitModal = () => {
    this.setState({
      showUnitModal: false,
      convertForm: {
        TwelveU12Unit: "",
        userUnit: "",
        TwelveU12Amount: "",
        userAmount: "",
      },
      unitDD: {
        TwelveU12Options: [],
        userOptions: [],
        TwelveU12Disabled: false,
        userDisabled: false,
      },
      unitMeta: {
        current_unit_list: [],
        final_unit_list: [],
        current_category: null,
        final_category: null,
        final_id: null,
        current_id: null,
        message_id: null,
        upc: null,
      },
    });
  };

  isConvertReady = () => {
    const f = this.state.convertForm || {};
    return (
      !!f.TwelveU12Unit &&
      !!f.userUnit &&
      !isZeroEquivalent(f.TwelveU12Amount) &&
      !isZeroEquivalent(f.userAmount)
    );
  };

  handleConvertClick = async () => {
    const { TwelveU12Amount, userAmount, TwelveU12Unit, userUnit } = this.state.convertForm || {};

    const amountValid =
      checkInput(TwelveU12Amount, TwelveU12Unit) &&
      checkInput(userAmount, userUnit);

    // Validate only on click; no borders, no inline errors
    if (!amountValid) {
      this.setState({
        showUnitModal: false
      })
      this.invalidValue.changeStatus();
      return;
    }

    try {
      await this.props.convertContributedItemUnit(
        this.state.activeUnitItem,
        this.state.convertForm,
      );
      this.closeUnitModal();
    } catch (e) {
      // show an error toast/modal if you want, but keep the modal open for correction
      this.setState({ showUnitModal: true });
    }
  };

  render() {
    const {
      t,
      isLoading,
      messageForm,
      messages,
      filteredMessages,
      messageFilter,
      selectedIndex,
      newDraft,
      isDraft,
      selectedDraft,
      isDirty,
      selectedConversation,
    } = this.props;

    const {
      showDirtyPrompt,
      promptObj,
      showClearPrompt,
      showRedirectPrompt,
      isLinkPrompt,
    } = this.state;

    const handleDirtyPrompt = (e) => {
      this.setState({ showRedirectPrompt: true, isLinkPrompt: e });
    };

    // --- TCP Trend helpers ---
    const isTrendAlert = (item) =>
      item &&
      item.type === "TCP";

    const normalizeTrendSymptoms = (item) => {
      // New backend: item.messages is an array of per-symptom blocks
      if (Array.isArray(item.messages) && item.messages.length) {
        return item.messages.map((m) => ({
          // per-item labels (fallback to item-level or i18n)
          symptom_label: t("general.CATEGORY_SYMPTOM"),
          cross_label:   t("message.POTENTIAL_ISSUE"),
          tik_label:     t("message.POTENTIAL_SAFE"),
          // values
          symptom_title: m.symptom_title || m.title || "",
          cross_items: Array.isArray(m.cross_items) ? m.cross_items : [],
          tik_items:   Array.isArray(m.tik_items)   ? m.tik_items   : [],
        }));
      }

      // Back-compat (old flat keys)
      return [{
        symptom_label: t("general.CATEGORY_SYMPTOM"),
        cross_label:   t("message.POTENTIAL_ISSUE"),
        tik_label:     t("message.POTENTIAL_SAFE"),
        symptom_title: item.symptom_title || "",
        cross_items: Array.isArray(item.cross_items) ? item.cross_items : [],
        tik_items:   Array.isArray(item.tik_items)   ? item.tik_items   : [],
      }];
    };

    const joinList = (arr) => (Array.isArray(arr) && arr.length ? arr.join(", ") : "—");
    // --- TCP Trend helpers ---

    const clickHereText = t("support.CLICK_HERE_LINK_TEXT"); // i18n key you asked to use

    const renderCompanyContent = (item) => {
      // Trend Alert: TCP payload with prefix/symptom blocks/suffix (new backend format)
      if (isTrendAlert(item)) {
        const symptoms = normalizeTrendSymptoms(item);

        // labels with safe fallbacks so UI remains stable
        const symptomLabel = t("general.CATEGORY_SYMPTOM");
        const issueLabel   = t("message.POTENTIAL_ISSUE");
        const safeLabel    = t("message.POTENTIAL_SAFE");

        return (
          <div>
            {/* prefix */}
            {item.prefix ? (
              <p style={{ marginBottom: 10 }}>
                <Highlighted
                  text={item.prefix}
                  highlight={(messageForm && messageForm.search) || ""}
                />
              </p>
            ) : null}

            {/* symptom blocks */}
            <div style={{ paddingLeft: 10 }}>
              {symptoms.map((s, idx) => (
                <div key={idx} style={{ marginBottom: 12 }}>
                  <div>
                    <strong>
                      <Highlighted
                        text={t("general.CATEGORY_SYMPTOM")}
                        highlight={(messageForm && messageForm.search) || ""}
                      />
                      :
                    </strong>{" "}
                    <Highlighted
                      text={s.symptom_title || "—"}
                      highlight={(messageForm && messageForm.search) || ""}
                    />
                  </div>
                  <div>
                    <strong>
                      <Highlighted
                        text={t("message.POTENTIAL_ISSUE")}
                        highlight={(messageForm && messageForm.search) || ""}
                      />
                      :
                    </strong>{" "}
                    <Highlighted
                      text={joinList(s.cross_items)}
                      highlight={(messageForm && messageForm.search) || ""}
                    />
                  </div>
                  <div>
                    <strong>
                      <Highlighted
                        text={t("message.POTENTIAL_SAFE")}
                        highlight={(messageForm && messageForm.search) || ""}
                      />
                      :
                    </strong>{" "}
                    <Highlighted
                      text={joinList(s.tik_items)}
                      highlight={(messageForm && messageForm.search) || ""}
                    />
                  </div>
                </div>
              ))}
            </div>

            {/* suffix */}
            {item.suffix ? (
              <p style={{ marginTop: 6, whiteSpace: "pre-line" }}>
                <Highlighted
                  text={t("message.TREND_ALERT_MESSAGE_TEXT")}
                  highlight={(messageForm && messageForm.search) || ""}
                />
              </p>
            ) : null}
          </div>
        );
      }


      // Only special handling for "Incompatible Measurement Unit"
      if (item.for === "contribute_category_mismatch" && item.content) {
        // Escape the text and split case-insensitively
        const esc = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

        // Consume optional whitespace around the phrase so we control spacing
        const re = new RegExp(`\\s*${esc(clickHereText)}\\s*`, "i");
        const parts = (item.content || "").split(re);

        // Clean boundary whitespace so we don't get double spaces
        const cleaned = parts.map((p, idx) => {
          if (idx === 0) return p.replace(/\s+$/g, "");                          // rtrim first
          if (idx === parts.length - 1) return p.replace(/^\s+/g, "");            // ltrim last
          return p.trim();                                                        // trim middle
        });

        // Interleave text parts with a clickable link that opens the modal
        return (
          <span>
            {cleaned.map((chunk, i) => (
              <React.Fragment key={i}>
                {/* keep search highlighting on all non-link text */}
                <Highlighted
                  text={chunk}
                  highlight={messageForm && messageForm.search ? messageForm.search : ""}
                />
                {i < cleaned.length - 1 ? (
                  <React.Fragment>
                    {" "}
                    <a
                      href=""
                      role="button"
                      draggable={false}   // avoid drag ghost
                      onClick={(e) => {
                        e.preventDefault();
                        this.openUnitModal(item);
                      }}
                      onContextMenu={(e) => e.preventDefault()} // 🚫 disable right-click menu
                    // style={{ textDecoration: "underline" }}
                    >
                      {/* ✅ highlight inside the link too */}
                      <Highlighted
                        text={clickHereText}
                        highlight={messageForm && messageForm.search ? messageForm.search : ""}
                      />
                    </a>
                    {" "}
                  </React.Fragment>
                ) : null}
              </React.Fragment>
            ))}
          </span>
        );
      }

      // All other company/TCP content stays as-is
      return (
        <Highlighted
          text={item.content || ""}
          highlight={messageForm && messageForm.search ? messageForm.search : ""}
          hasLink={item.post_id ? item.post_id : undefined}
          isDirty={isDirty}
          handleDirtyPrompt={handleDirtyPrompt}
          title={item.title}
        />
      );
    };

    return (
      <div>
        <Loading isLoading={isLoading} />
        <Valert
          display={showRedirectPrompt}
          title={
            this.props.newDraft
              ? t("forum.DRAFT_UNSAVED_REPLY_TITLE")       // ✅ new reply → reply title
              : (isDraft
                  ? (isLinkPrompt
                      ? t("forum.DRAFT_UNSAVED_TITLE")     // editing a draft + link nav
                      : t("forum.DRAFT_NOT_SAVED_TITLE"))  // editing a draft (non-link)
                  : t("forum.DRAFT_UNSAVED_REPLY_TITLE"))  // regular reply compose
          }
          question={
            isDraft
              ? t("message.DRAFT_NOT_SAVED_TEXT_4")
              : t("message.DRAFT_NOT_SAVED_TEXT_3")
          }
          onRef={(ref) => (this.dirtyAlert = ref)}
          positiveAction={() => {
            setTimeout(() => {
              if (isLinkPrompt) {
                window.location.href = `/forum/post/${isLinkPrompt}`;
              } else {
                this.setState({ showRedirectPrompt: false });
              }
            }, 10);
          }}
          positiveText={t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={t("general.CANCEL")}
          negativeAction={() => {
            setTimeout(() => {
              this.setState({ showRedirectPrompt: false, isLinkPrompt: null });
            }, 10);
          }}
        />
        <Valert
          display={showClearPrompt}
          title={t("general.CLEAR_CONFIRMATION_TITLE")}
          question={t("inbox.CLEAR_REPLY_TEXT")}
          positiveAction={() => {
            this.props.clearMessage();
            if (this.props.newDraft && !this.props.isDraft) {
              this.props.clearDirtyDraft();
            }
            setTimeout(() => {
              this.setState({ showClearPrompt: false });
            }, 10);
          }}
          positiveText={t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={t("general.CANCEL")}
          negativeAction={() => {
            setTimeout(() => {
              this.setState({ showClearPrompt: false });
            }, 10);
          }}
        />
        <Valert
          display={showDirtyPrompt && messageForm.message != selectedDraft}
          title={t("forum.DRAFT_NOT_SAVED_TITLE")}
          question={t("message.DRAFT_NOT_SAVED_TEXT_2")}
          onRef={(ref) => (this.dirtyAlert = ref)}
          positiveAction={() => {
            let con = promptObj.con;
            let post = promptObj.post;
            let i = promptObj.i;
            this.props.clearDirtyDraft();
            setTimeout(() => {
              this.handleReply(con, post, i);
              this.setState({ showDirtyPrompt: false, promptObj: {} });
            }, 10);
          }}
          positiveText={t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={t("general.CANCEL")}
          negativeAction={() => {
            setTimeout(() => {
              this.setState({ showDirtyPrompt: false });
            }, 10);
          }}
        />
        <Valert
          display={false}
          title={
            isDraft &&
              !newDraft &&
              messageForm.message != selectedDraft &&
              selectedIndex != this.state.deleteIndex
              ? t("forum.DRAFT_NOT_SAVED_TITLE")
              : newDraft &&
                isDraft &&
                messageForm.message.length > 0 &&
                selectedIndex !== this.state.deleteIndex
                ? t("forum.DRAFT_NOT_SAVED_TITLE")
                : newDraft &&
                  !isDraft &&
                  messageForm.message &&
                  messageForm.message.length > 0 &&
                  selectedIndex != this.state.deleteIndex
                  ? t("inbox.INCOMPLETE_REPLY_TITLE")
                  : t("general.DELETE_CONFIRMATION_TITLE")
          }
          question={
            isDraft &&
              !newDraft &&
              messageForm.message != selectedDraft &&
              selectedIndex != this.state.deleteIndex
              ? t("message.DRAFT_NOT_SAVED_DELETE_TEXT")
              : newDraft &&
                isDraft &&
                messageForm.message.length > 0 &&
                selectedIndex !== this.state.deleteIndex
                ? t("message.DRAFT_NOT_SAVED_DELETE_TEXT")
                : newDraft &&
                  !isDraft &&
                  messageForm.message &&
                  messageForm.message.length > 0 &&
                  selectedIndex != this.state.deleteIndex
                  ? t("inbox.INCOMPLETE_REPLY_TEXT")
                  : t("inbox.DELETE_MESSAGE_TEXT")
          }
          onRef={(ref) => (this.deleteAlert = ref)}
          positiveAction={() => {
            this.props.messageDelete(this.deleteId);
          }}
          positiveText={t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={t("general.CANCEL")}
        />

        <Valert
          display={false}
          title={t("message.REPLY_NOT_SAVED_TITLE")}
          question={t("message.REPLY_NOT_SAVED_TEXT")}
          onRef={(ref) => (this.unfinishedReply = ref)}
          positiveAction={() => {
            this.posClicked();
            this.props.clearDirtyDraft();
          }}
        />
        <Valert
          display={false}
          onRef={(ref) => (this.invalidValue = ref)}
          title={t("general.INVALID_VALUE_TITLE")}
          question={t("general.INVALID_VALUE_TEXT")}
          positiveText={t("general.OK_PROMPT_TEXT")}
          positiveAction={() => {
            this.setState({
              showUnitModal: true
            })
          }}
          readOnly={true}
        />

        <Vmodal
          displayStatus={
            this.props.draftStatus && !this.props.published && !isLoading
          }
          data={
            this.props.newDraft ? (
              <div
                style={{
                  marginLeft: "15px",
                  marginRight: "15px",
                }}
              >
                <h4>{t("message.MESSAGE_DRAFT_SAVED_TITLE")}</h4>
                <p>{t("message.MESSAGE_DRAFT_SAVED_TEXT")}</p>
              </div>
            ) : (
              <div
                style={{
                  marginLeft: "15px",
                  marginRight: "15px",
                }}
              >
                <h4>{t("message.MESSAGE_DRAFT_UPDATED_TITLE")}</h4>
                <p>{t("message.MESSAGE_DRAFT_UPDATED_TEXT")}</p>
              </div>
            )
          }
          closeFunc={() => {
            this.props.clearDirtyDraft();
            window.location.reload();
          }}
          timedClose={2000}
        />
        <Vmodal
          displayStatus={
            this.props.published && !this.props.draftStatus && !isLoading
          }
          data={
            <div>
              <h4>{t("message.SEND_SUCCESSFULLY_TITLE")}</h4>
              <p>{t("message.SEND_SUCCESSFULLY_TEXT")}</p>
            </div>
          }
          closeFunc={() => {
            this.props.clearDirtyDraft();
            window.location.reload();
          }}
          timedClose={2000}
        />
        <Vmodal
          displayStatus={this.props.convertSuccess}
          data={
            <div>
              <h4>{t("message.CONVERTED_SUCCESSFULLY_TITLE")}</h4>
              <p>{t("message.CONVERTED_SUCCESSFULLY_TEXT")}</p>
            </div>
          }
          // closeFunc={() => {}}
          closeFunc={this.props.clearRecalcSuccess}

          timedClose={2000}
        />

        <Vmodal
          displayStatus={this.state.showUnitModal}
          closeFunc={this.closeUnitModal}
          data={
            <div style={{ marginLeft: 15, marginRight: 15, paddingTop: 20 }}>
              {/* Title */}
              <h4 style={{ fontWeight: 700, margin: "0 0 13px 0" }}>
                {t("message.CONTRIBUTED_ITEM_UNIT_CONVERSION_TITLE")}
              </h4>

              {/* Body text */}
              <p style={{ margin: "0 0 25px 0", lineHeight: 1.4 }}>
                {t("message.CONTRIBUTED_ITEM_UNIT_CONVERSION_TEXT_1")}
              </p>

              {/* Column headers */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr auto 1fr", // add middle col for '=' below
                  columnGap: 10,       // spec: 10px between columns
                  marginTop: 25,       // spec: space between text & column title
                  marginBottom: 10     // spec: space between column title & fields
                }}
              >
                <div style={{ fontWeight: 700, fontSize: "1rem", textAlign: "center" }}>
                  {t("message.12U12")}
                </div>

                {/* empty spacer column so the rows below can show '=' in the same spot */}
                <div style={{ width: 16 }} aria-hidden="true" />

                <div style={{ fontWeight: 700, fontSize: "1rem", textAlign: "center" }}>
                  {t("message.USER")}
                </div>
              </div>

              {/* Row 1: Units (Dropdowns) */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr auto 1fr", // left field, '=', right field
                  columnGap: 10,       // spec: 10px between two fields
                  marginBottom: 10,     // spec: 10px between two field rows
                  alignItems: "center",
                }}
              >

                {/* 12u12 Unit */}
                <UnitDropdown
                  name="TwelveU12Unit"
                  value={this.state.convertForm.TwelveU12Unit}
                  options={this.state.unitDD.TwelveU12Options}
                  disabled={this.state.unitDD.TwelveU12Disabled}
                  placeholder={
                    (this.state.unitDD.TwelveU12Disabled || this.state.unitDD.TwelveU12Options.length === 1)
                      ? ""
                      : this.props.t("message.12U12_UNIT")
                  }
                  onChange={(val) =>
                    this.setState({
                      convertForm: { ...this.state.convertForm, TwelveU12Unit: val },
                    })
                  }
                />

                {/* equal sign*/}
                <div
                  style={{ textAlign: "center", fontWeight: 400, minWidth: 16 }}
                >
                  =
                </div>

                {/* User Unit */}
                <UnitDropdown
                  name="userUnit"
                  value={this.state.convertForm.userUnit}
                  options={this.state.unitDD.userOptions}
                  disabled={this.state.unitDD.userDisabled}
                  placeholder={
                    (this.state.unitDD.userDisabled || this.state.unitDD.userOptions.length === 1)
                      ? ""
                      : this.props.t("message.USER_UNIT")
                  }
                  onChange={(val) =>
                    this.setState({
                      convertForm: { ...this.state.convertForm, userUnit: val },
                    })
                  }
                />
              </div>

              {/* Row 2: Amounts */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr auto 1fr", // left field, '=', right field
                  columnGap: 10,       // spec: 10px between two fields
                  marginBottom: 30,     // spec: space between fields & Convert button
                  alignItems: "center",
                }}
              >
                {/* 12u12 Amount */}
                <Input
                  className="form-control"
                  placeholder={t("message.12U12_AMOUNT")}
                  value={this.state.convertForm.TwelveU12Amount}
                  maxLength={5}
                  onChange={(e) => {
                    const next = this.TwelveU12Amt.onChange(e.target.value);
                    this.setState((prev) => ({
                      convertForm: { ...prev.convertForm, TwelveU12Amount: next },
                    }))
                  }}
                  onBeforeInput={(e) => {
                    const el = e.currentTarget;
                    const ok = this.TwelveU12Amt.onBeforeInput(
                      el.value,
                      e.data || "",
                      el.selectionStart || el.value.length,
                      el.selectionEnd || el.value.length
                    );
                    if (!ok) e.preventDefault();
                  }}
                  onPaste={(e) => {
                    e.preventDefault();
                    const el = e.currentTarget;
                    const pasted = (e.clipboardData || window.clipboardData).getData("text") || "";
                    const next = this.TwelveU12Amt.onPaste(
                      el.value,
                      pasted,
                      el.selectionStart || el.value.length,
                      el.selectionEnd || el.value.length
                    );
                    this.setState((prev) => ({
                      convertForm: { ...prev.convertForm, TwelveU12Amount: next },
                    }));
                  }}
                  onDrop={(e) => e.preventDefault()}
                  onDragOver={(e) => e.preventDefault()}
                  mode="decimal"
                />

                <div
                  style={{ textAlign: "center", fontWeight: 400, minWidth: 16 }}
                >
                  =
                </div>

                {/* User Amount */}
                <Input
                  className="form-control"
                  placeholder={t("message.USER_AMOUNT")}
                  value={this.state.convertForm.userAmount}
                  maxLength={5}
                  onChange={(e) => {
                    const next = this.userAmt.onChange(e.target.value);
                    this.setState((prev) => ({
                      convertForm: { ...prev.convertForm, userAmount: next },
                    }))
                  }}
                  onBeforeInput={(e) => {
                    const el = e.currentTarget;
                    const ok = this.userAmt.onBeforeInput(
                      el.value,
                      e.data || "",
                      el.selectionStart || el.value.length,
                      el.selectionEnd || el.value.length
                    );
                    if (!ok) e.preventDefault();
                  }}
                  onPaste={(e) => {
                    e.preventDefault();
                    const el = e.currentTarget;
                    const pasted = (e.clipboardData || window.clipboardData).getData("text") || "";
                    const next = this.userAmt.onPaste(
                      el.value,
                      pasted,
                      el.selectionStart || el.value.length,
                      el.selectionEnd || el.value.length
                    );
                    this.setState((prev) => ({
                      convertForm: { ...prev.convertForm, userAmount: next },
                    }));
                  }}
                  onDrop={(e) => e.preventDefault()}
                  onDragOver={(e) => e.preventDefault()}
                />
              </div>

              {/* Body text */}
              <p style={{ margin: "0 0 25px 0", lineHeight: 1.4 }}>
                {t("message.CONTRIBUTED_ITEM_UNIT_CONVERSION_TEXT_2")}
              </p>

              {/* Button */}
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button
                  color="primary"
                  disabled={!this.isConvertReady()}
                  onClick={this.handleConvertClick}
                >
                  {t("message.CONVERT_BUTTON")}
                </Button>
              </div>
            </div>
          }
        />
        <div className="vPage flex">
          <MessageForm
            t={this.props.t}
            onSubmit={this.handleFilter.bind(this)}
            myId={this.state.myId}
            messageForm={messageForm}
            messageFilter={messageFilter}
            onChangeForm={this.props.onChangeForm.bind(this)}
            selectedConversation={this.props.selectedConversation}
            myRef={this.myRef}
          />
          <div
            className="recipeList grayList"
            style={{ flex: 1, marginBottom: "10px" }}
            ref={this.myRef}
          >
            {messageForm.search && messageForm.search.length > 0
              ? filteredMessages.map((item, index) => {
                const theUser = (id) => {
                  return id == this.loggedInUser._id
                    ? t("message.YOU_TEXT")
                    : id;
                };

                const isExpand =
                  typeof item.isExpand && item.isExpand != "undefined"
                    ? item.isExpand
                    : false;

                const ingredientTogglerClass = classNames(
                  "fas",
                  { "fa-chevron-down": !isExpand },
                  { "fa-chevron-up": isExpand }
                );
                const firstMsgLen = Array.isArray(item.messages) && item.messages[0] && item.messages[0].message
                  ? item.messages[0].message.length
                  : 0;

                const togglerStyle = {
                  height: item.isExpand
                    ? "auto"
                    : (firstMsgLen && firstMsgLen < 50) || (["company", "TCP", "update_nutrient", "update_name"].includes(item.type))
                      ? "4.15rem"
                      : (firstMsgLen && firstMsgLen > 50) || (item.title && item.title.length > 50) || (["company", "TCP", "update_nutrient", "update_name"].includes(item.type))
                        ? "3.7rem"
                        : "2.75rem",
                  paddingTop: "0px",
                  paddingBottom: "0px",
                  marginBottom: "0px",
                  backgroundColor: item.isSelected ? "#718afa1a" : "inherit",
                  overflow: "hidden",
                  border: `10px solid ${
                    item.isSelected
                      ? "rgba(113, 138, 250, 0.00001)"
                      : "#F9FAFB"
                  }`,
                };




                let date = item.date / 1000;
                return (
                  <ul className="recipe-item message-card" key={index}>
                    <li className="wrapper" style={togglerStyle}>
                      <Row>
                        <Col xs="1">
                          <i
                            className={ingredientTogglerClass}
                            style={{
                              fontSize: "14px",
                              color: "#007bff",
                              cursor: "pointer",
                              fontSize: "14px",
                              color: "#007bff",
                              cursor: "pointer",
                              marginTop: "0px",
                            }}
                            onClick={() => {
                              this.props.messageToggle(item, index);
                            }}
                          ></i>
                        </Col>
                        <Col xs="9">
                          {item.type !== "TCP" &&
                            item.messages &&
                            item.messages.map((message) => {
                              let date = message.date && message.date / 1000;
                              let sender =
                                item.type == "feedback" && message.sender
                                  ? message.sender
                                  : message.sender && message.sender._id;
                              let editedSender =
                                sender == "12U12"
                                  ? sender.toLocaleLowerCase()
                                  : sender == "you"
                                    ? t("message.YOU_TEXT")
                                    : sender;
                              return (
                                <p
                                  style={{
                                    fontSize: "0.8rem",
                                    marginLeft: "-15px",
                                    marginBottom:
                                      message.message &&
                                        message.message.length > 1
                                        ? "5px"
                                        : "0px",
                                    wordBreak: "break-word",
                                    whiteSpace: "pre-line",
                                  }}
                                >
                                  <span>
                                    {
                                      moment
                                        .unix(date)
                                        .format("DD MMM YY, hh:mma")
                                    }
                                  </span>
                                  <Highlighted
                                    text={`${theUser(editedSender)}:`}
                                    highlight={
                                      messageForm && messageForm.search
                                        ? messageForm.search
                                        : ""
                                    }
                                    hasLink={
                                      item.post_id ? item.post_id : undefined
                                    }
                                  />
                                  <span
                                    style={{
                                      color: "#FF0000",
                                      fontSize: "0.8rem",
                                      marginBottom: message.message.length
                                        ? "5px"
                                        : "0px",
                                      wordBreak: "break-word",
                                    }}
                                  >
                                    {message.is_draft
                                      ? " " + t("forum.DRAFT_TEXT")
                                      : ""}
                                  </span>
                                  <Highlighted
                                    text={message.message}
                                    highlight={
                                      messageForm && messageForm.search
                                        ? messageForm.search
                                        : ""
                                    }
                                  />
                                </p>
                              );
                            })}
                          {item.type == "feedback" && item.title && (
                            <p
                              style={{
                                fontSize: "0.8rem",
                                marginLeft: "-15px",
                                wordBreak: "break-word",
                                whiteSpace: "pre-line",
                                marginBottom: item.messages.length
                                  ? "5px"
                                  : "0px",
                              }}
                            >
                              <span>
                                {
                                  moment
                                    .unix(date)
                                    .format("DD MMM YY, hh:mma")
                                }
                              </span>
                              {/* {" "} */}
                              <Highlighted
                                text={`${theUser(t("message.YOU_TEXT"))}:`}
                                highlight={
                                  messageForm && messageForm.search
                                    ? messageForm.search
                                    : ""
                                }
                                hasLink={
                                  item.post_id ? item.post_id : undefined
                                }
                              />
                              <span
                                style={{
                                  color: "#FF0000",
                                }}
                              >
                              </span>
                              <Highlighted
                                text={item.title}
                                highlight={
                                  messageForm && messageForm.search
                                    ? messageForm.search
                                    : ""
                                }
                                hasLink={
                                  item.post_id ? item.post_id : undefined
                                }
                              />
                            </p>
                          )}
                          {(["company", "TCP", "update_nutrient", "update_name"].includes(item.type)) ? (
                            <div
                              style={{
                                fontSize: "0.8rem",
                                paddingRight: "25px",
                                marginLeft: "-15px",
                                marginBottom: "0px",
                                paddingTop: item.title ? "2px" : "0px",
                              }}
                            >
                              <span>
                                {item.date.toString().length >= 13
                                  ? moment
                                    .unix(item.date.toString().slice(0, 10))
                                    .format("DD MMM YY, hh:mma")
                                  : moment
                                    .unix(item.date)
                                    .format("DD MMM YY, hh:mma")}
                                {" "}
                              </span>
                              <Highlighted
                                text={"12u12: "}
                                highlight={
                                  messageForm && messageForm.search
                                    ? messageForm.search
                                    : ""
                                }
                                hasLink={
                                  item.post_id ? item.post_id : undefined
                                }
                              />

                              {(item.content || isTrendAlert(item)) && (
                                <div>
                                  <p
                                    style={{
                                      marginTop: "10px",
                                      marginBottom: item.messages.length
                                        ? "5px"
                                        : "0px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {
                                      <Highlighted
                                        text={item.title}
                                        highlight={
                                          messageForm && messageForm.search
                                            ? messageForm.search
                                            : ""
                                        }
                                        hasLink={
                                          item.post_id
                                            ? item.post_id
                                            : undefined
                                        }
                                      />
                                    }
                                  </p>
                                  <p>
                                    {/* <Highlighted
                                      text={item.content}
                                      highlight={
                                        messageForm && messageForm.search
                                          ? messageForm.search
                                          : ""
                                      }
                                      hasLink={
                                        item.post_id
                                          ? item.post_id
                                          : undefined
                                      }
                                      isDirty={isDirty}
                                      handleDirtyPrompt={handleDirtyPrompt}
                                      title={item.title}
                                    /> */}
                                    {renderCompanyContent(item)}
                                  </p>
                                </div>
                              )}
                              {/* {item.post.body} */}
                            </div>
                          ) : (
                            <div
                              style={{
                                fontSize: "0.8rem",
                                paddingRight: "25px",
                                marginLeft: "-15px",
                                wordBreak: "break-word",
                                whiteSpace: "pre-line",
                                marginBottom: item.messages.length
                                  ? "5px"
                                  : "0px",
                              }}
                            >
                              {item.post && item.post.date && (
                                <span>
                                  {item.post.date.toString().length >= 13
                                    ? moment
                                      .unix(
                                        item.post.date
                                          .toString()
                                          .slice(0, 10)
                                      )
                                      .format("DD MMM YY, hh:mma")
                                    : moment
                                      .unix(item.post.date)
                                      .format("DD MMM YY, hh:mma")}
                                </span>
                              )}
                              <span>
                                {item.post && (
                                  <Highlighted
                                    text={`${theUser(item.post.user)}:`}
                                    highlight={
                                      messageForm && messageForm.search
                                        ? messageForm.search
                                        : ""
                                    }
                                  />
                                )}
                              </span>
                              {item.post && item.post.body && (
                                <Highlighted
                                  text={item.post.body}
                                  highlight={
                                    messageForm && messageForm.search
                                      ? messageForm.search
                                      : ""
                                  }
                                  hasLink={
                                    item.post_id ? item.post_id : undefined
                                  }
                                />
                              )}
                              {/* {item.post.body} */}
                            </div>
                          )}
                        </Col>
                        <Col xs="1">
                          {!item.isSelected &&
                            item.messages.some((e) => e.is_draft === true) ? (
                            <i
                              className="fa fa-pencil-alt defIcon"
                              onClick={() => {
                                this.handleReply(
                                  item._id,
                                  item.post ? item.post._id : "",
                                  index
                                );
                              }}
                              style={{
                                paddingLeft: "25px",
                                color: "#007bff",
                                cursor: "pointer",
                                fontSize: "14px",
                              }}
                            ></i>
                          ) : item.isSelected ? (
                            <i
                              className="fa fa-pencil-alt defIcon"
                              onClick={() => {
                                this.handleReply(
                                  item._id,
                                  item.post ? item.post._id : "",
                                  index
                                );
                              }}
                              style={{
                                paddingLeft: "25px",
                                color: "red",
                                cursor: "pointer",
                                fontSize: "14px",
                              }}
                            ></i>
                          ) : (
                            <i
                              className="fa fa-reply"
                              style={{
                                paddingLeft: "25px",
                                color: "#007bff",
                                cursor: "pointer",
                                fontSize: "14px",
                                display: (["company", "TCP", "update_nutrient", "update_name"].includes(item.type)) && "none",
                              }}
                              onClick={() => {
                                this.handleReply(
                                  item._id,
                                  item.post ? item.post._id : "",
                                  index
                                );
                              }}
                            ></i>
                          )}
                        </Col>
                        <Col xs="1">
                          <i
                            className="far fa-trash-alt defIcon"
                            onClick={() => this.handleDelete(item._id, index)}
                            style={{
                              paddingRight: "15px",
                              color: "#007bff",
                              cursor: "pointer",
                              fontSize: "14px",
                              paddingLeft: "10px",
                            }}
                          ></i>
                        </Col>
                      </Row>
                    </li>
                  </ul>
                );
              })
              // When the keyword field is empty
              : messages &&
              messages.length > 0 &&
              messages.map((item, index) => {
                const theUser = (id) => {
                  return id == this.loggedInUser._id
                    ? t("message.YOU_TEXT")
                    : id;
                };

                const isExpand =
                  typeof item.isExpand && item.isExpand != "undefined"
                    ? item.isExpand
                    : false;
                const ingredientTogglerClass = classNames(
                  "fas",
                  { "fa-chevron-down": !isExpand },
                  { "fa-chevron-up": isExpand }
                );

                const firstMsgLen = Array.isArray(item.messages) && item.messages[0] && item.messages[0].message
                  ? item.messages[0].message.length
                  : 0;

                const togglerStyle = {
                  height: item.isExpand
                    ? "auto"
                    : (firstMsgLen && firstMsgLen < 50) || (["company", "TCP", "update_nutrient", "update_name"].includes(item.type))
                      ? "4.15rem"
                      : (firstMsgLen && firstMsgLen > 50) || (item.title && item.title.length > 50) || (["company", "TCP", "update_nutrient", "update_name"].includes(item.type))
                        ? "3.7rem"
                        : "2.75rem",
                  paddingTop: "0px",
                  paddingBottom: "0px",
                  marginBottom: "0px",
                  backgroundColor: item.isSelected ? "#718afa1a" : "inherit",
                  overflow: "hidden",
                  border: `10px solid ${
                    item.isSelected
                      ? "rgba(113, 138, 250, 0.00001)"
                      : "#F9FAFB"
                  }`,
                };

                return (
                  <ul className="recipe-item message-card" key={index}>
                    <li className="wrapper" style={togglerStyle}>
                      <Row>
                        <Col xs="1">
                          <i
                            className={ingredientTogglerClass}
                            style={{
                              fontSize: "14px",
                              color: "#007bff",
                              cursor: "pointer",
                              marginTop: "0px",
                            }}
                            onClick={() => {
                              this.props.messageToggle(item, index);
                            }}
                          ></i>
                        </Col>
                        <Col xs="9">
                          {item.type !== "TCP" &&
                            item.messages &&
                            item.messages.map((message) => {
                              let date = message.date && message.date / 1000;
                              let sender =
                                message.sender && message.sender._id
                                  ? message.sender._id
                                  : message.sender;
                              let editedSender =
                                sender == "12U12"
                                  ? sender.toLocaleLowerCase()
                                  : sender == "you"
                                    ? t("message.YOU_TEXT")
                                    : sender;
                              return item.type === "company" ? (
                                <div>
                                  <p
                                    style={{
                                      fontSize: "0.8rem",
                                      paddingRight: "25px",
                                      marginLeft: "-15px",
                                      marginBottom: "0px",
                                      wordBreak: "break-word",
                                      whiteSpace: "pre-line",
                                    }}
                                  >
                                    <span>
                                      {`${moment
                                        .unix(date)
                                        .format("DD MMM YY, hh:mma")} 12u12: `}
                                    </span>
                                    <span
                                      style={{
                                        color: "#FF0000",
                                        // marginLeft: 3,
                                      }}
                                    >
                                      {message.is_draft
                                        ? " " + t("forum.DRAFT_TEXT")
                                        : ""}
                                    </span>
                                  </p>
                                  <p
                                    style={{
                                      fontWeight: "bold",
                                      fontSize: "0.8rem",
                                      marginLeft: "-15px",
                                      marginBottom: "0px",
                                    }}
                                  >
                                    <Highlighted
                                      text={message.title}
                                      highlight={
                                        messageForm && messageForm.search
                                          ? messageForm.search
                                          : ""
                                      }
                                      hasLink={
                                        message.post_id
                                          ? message.post_id
                                          : undefined
                                      }
                                    />
                                    {/* {item.title} */}
                                  </p>
                                  <p
                                    style={{
                                      fontSize: "0.8rem",
                                      marginLeft: "-15px",
                                      marginBottom: "0px",
                                    }}
                                  >
                                    <Highlighted
                                      text={message.content}
                                      highlight={
                                        messageForm && messageForm.search
                                          ? messageForm.search
                                          : ""
                                      }
                                      hasLink={
                                        message.post_id
                                          ? message.post_id
                                          : undefined
                                      }
                                    />
                                  </p>
                                </div>
                              ) : (
                                <p
                                  style={{
                                    fontSize: "0.8rem",
                                    marginLeft: "-15px",
                                    marginBottom: message.message.length
                                      ? "5px"
                                      : "0px",
                                    wordBreak: "break-word",
                                    whiteSpace: "pre-line",
                                  }}
                                >
                                  <span>
                                    {moment
                                      .unix(date)
                                      .format("DD MMM YY, hh:mma")}{" "}
                                    {theUser(editedSender)}:
                                  </span>
                                  {message.is_draft && " "}
                                  {message.is_draft && (
                                    <span
                                      style={{
                                        color: "#FF0000",
                                      }}
                                    >
                                      {t("forum.DRAFT_TEXT")}
                                    </span>
                                  )}
                                  <span>  
                                    <Highlighted
                                      text={message.message}
                                      highlight={
                                        messageForm && messageForm.search
                                          ? messageForm.search
                                          : ""
                                      }
                                      hasLink={
                                        item.post_id
                                          ? item.post_id
                                          : undefined
                                      }
                                    />
                                  </span>
                                </p>
                              );
                            })}
                          <div
                            style={{
                              fontSize: "0.8rem",
                              paddingRight: "25px",
                              marginLeft: "-15px",
                              marginBottom: "0px",
                              paddingTop: item.title ? "2px" : "0px",
                              wordBreak: "break-word",
                              whiteSpace: "pre-line",
                            }}
                          >
                            {item.post && item.post.date ? (
                              <span>
                                {item.post.date.toString().length >= 13
                                  ? moment
                                    .unix(
                                      item.post.date.toString().slice(0, 10)
                                    )
                                    .format("DD MMM YY, hh:mma")
                                  : moment
                                    .unix(item.post.date)
                                    .format("DD MMM YY, hh:mma")}
                              </span>
                            ) : (
                              <span>
                                {item.date.toString().length >= 13
                                  ? moment
                                    .unix(item.date.toString().slice(0, 10))
                                    .format("DD MMM YY, hh:mma")
                                  : moment
                                    .unix(item.date)
                                    .format("DD MMM YY, hh:mma")}
                              </span>
                            )}
                            <Highlighted
                              text={
                                `${theUser(
                                  item.post
                                    ? item.post.user
                                    : item.type == "feedback"
                                      ? t("message.YOU_TEXT")
                                      : (["company", "TCP", "update_nutrient", "update_name"].includes(item.type)) && "12u12"
                                )}:`
                              }
                              highlight={
                                messageForm && messageForm.search
                                  ? messageForm.search
                                  : ""
                              }
                            />

                            {(["company", "TCP", "update_nutrient", "update_name"].includes(item.type)) ? (
                              <div>
                                <p style={{ fontWeight: "bold" }}>
                                  <Highlighted
                                    text={item.title}
                                    highlight={
                                      messageForm && messageForm.search
                                        ? messageForm.search
                                        : ""
                                    }
                                  />
                                  {/* {item.title} */}
                                </p>
                                <p
                                  style={{
                                    marginTop: "0px",
                                    marginBottom: "0px",
                                  }}
                                >
                                  {renderCompanyContent(item)}
                                  {/* {item.content} */}
                                </p>
                              </div>
                            ) : item.post && item.post.body ? (
                              <Highlighted
                                text={item.post.body}
                                highlight={
                                  messageForm && messageForm.search
                                    ? messageForm.search
                                    : ""
                                }
                                hasLink={
                                  item.post_id ? item.post_id : undefined
                                }
                              />
                            ) : (
                              <Highlighted
                                text={
                                  item.type == "feedback"
                                    ? item.title
                                    : item.content
                                }
                                highlight={
                                  messageForm && messageForm.search
                                    ? messageForm.search
                                    : ""
                                }
                                hasLink={
                                  item.post_id ? item.post_id : undefined
                                }

                              />
                            )}
                            {/* {item.post.body} */}
                          </div>
                        </Col>
                        <Col xs="1">
                          {!item.isSelected &&
                            item.messages.some((e) => e.is_draft == true) ? (
                            <i
                              className="fa fa-pencil-alt defIcon"
                              onClick={() => {
                                this.handleReply(
                                  item._id,
                                  item.post ? item.post._id : "",
                                  index
                                );
                              }}
                              style={{
                                display: (["company", "TCP", "update_nutrient", "update_name"].includes(item.type)) && "none",
                                paddingLeft: "25px",
                                color: "#007bff",
                                cursor: "pointer",
                                fontSize: "14px",
                              }}
                            ></i>
                          ) : item.isSelected ? (
                            <i
                              className="fa fa-pencil-alt defIcon"
                              onClick={() => {
                                this.handleReply(
                                  item._id,
                                  item.post ? item.post._id : "",
                                  index
                                );
                              }}
                              style={{
                                paddingLeft: "25px",
                                color: "red",
                                cursor: "pointer",
                                fontSize: "14px",
                              }}
                            ></i>
                          ) : (
                            <i
                              className="fa fa-reply"
                              style={{
                                paddingLeft: "25px",
                                color: "#007bff",
                                cursor: "pointer",
                                fontSize: "14px",
                                display: (["company", "TCP", "update_nutrient", "update_name"].includes(item.type)) && "none",
                              }}
                              onClick={() => {
                                this.handleReply(
                                  item._id,
                                  item.post ? item.post._id : "",
                                  index
                                );
                              }}
                            ></i>
                          )}
                        </Col>
                        <Col xs="1">
                          <i
                            className="far fa-trash-alt defIcon"
                            onClick={() => this.handleDelete(item._id, index)}
                            style={{
                              paddingRight: "15px",
                              color: "#007bff",
                              cursor: "pointer",
                              fontSize: "14px",
                              paddingLeft: "10px",
                            }}
                          ></i>
                        </Col>
                      </Row>
                    </li>
                  </ul>
                );
              })}

            {!isLoading && messageForm.search && messageForm.search.length > 0
              ? filteredMessages &&
              filteredMessages.length == 0 && (
                <div
                  style={{
                    fontSize: 12.8,
                    padding: "4px 0 4px 4px",
                    backgroundColor: "white",
                    color: "#212529",
                    borderRadius: 3,
                    margin: 0,
                    boxShadow:
                      "0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)",
                  }}
                >
                  {t("general.NO_MATCH_FOUND")}
                </div>
              )
              : messages &&
              messages.length == 0 && (
                <div
                  style={{
                    fontSize: 12.8,
                    padding: "4px 0 4px 4px",
                    backgroundColor: "white",
                    color: "#212529",
                    lineHeight: 1.5,
                    borderRadius: 3,
                    margin: 0,
                    boxShadow:
                      "0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)",
                  }}
                >
                  {t("general.NO_MESSAGES_FOUND")}
                </div>
              )}
          </div>
          <Row className="form-group">
            <Col>
              <InputText
                type="textarea"
                placeholder={t("message.TYPE_HERE_PLACEHOLDER")}
                disabled={this.props.selectedConversation ? false : true}
                input={{
                  onChange: (e) =>
                    this.props.onChangeForm(
                      e.target.value,
                      "message",
                      this.state.myId
                    ),
                  name: "message",
                  value: messageForm && messageForm.message,
                }}
                style={{ height: "15vh" }}
                meta={{}}
                maxLength={5000}
              />
            </Col>
          </Row>
          <div className="row formRow">
            <div className="col">
              <button
                type="button"
                className="btn btn-primary btnWide"
                onClick={() => {
                  this.props.isDraft
                    ? this.handlePublish(true)
                    : this.handleSubmit(true);
                }}
                
                disabled={
                  messageForm &&
                    messageForm.message &&
                    this.props.selectedDraft != this.props.messageForm.message
                    ? false
                    : true
                }
              >
                {this.props.isDraft
                  ? t("forum.EDIT_DRAFT_BUTTON")
                  : t("forum.SAVE_DRAFT_BUTTON")}
              </button>
            </div>
            <div className="col">
              <button
                className="btn btn-primary btnWide"
                disabled={
                  messageForm && messageForm.message
                    ? false
                    : true
                }
                onClick={() => {
                  this.props.isDraft
                    ? this.handlePublish(false)
                    : this.handleSubmit(false);
                }}
              >
                {t("message.SEND_BUTTON_TITLE")}
              </button>
            </div>
            <div className="col">
              <button
                type="button"
                className="btn btn-primary btnWide"
                onClick={() => {
                  setTimeout(() => {
                    this.setState({ showClearPrompt: true });
                  }, 10);
                }}
                disabled={
                  messageForm && messageForm.message
                    ? false
                    : true
                }
              >
                {t("message.CLEAR_TEXT_BOX")}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

MessagingInbox = translate("translations")(MessagingInbox);

const mapStateToProps = (state) => ({
  ...state.message,
});

const matchDispatchToProps = (dispatch) =>
  bindActionCreators({ ...messageActions }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(MessagingInbox);



// WEBPACK FOOTER //
// ./src/pages/Message.js